import { KYMW1318Model } from '../kymw1318.model';
import { GetDeletePlanGoodsInfoModel } from '../vo/kymw1318-get-delete-plan-goods-info.model';
import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetDeletePlanGoodsInfoResponse = {
  DeletePlanGoodsTargetList: [
    {
      OrderCode: string;
      MediumType: string;
      MediumName: string;
      ConfirmedFlg: string;
    }
  ]
}

/**
 * 選定解除対象情報取得サービス
 *
 * @export GetDeletePlanGoodsInfoService
 * @class GetDeletePlanGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetDeletePlanGoodsInfoService extends PlessJsonResponderSub<GetDeletePlanGoodsInfoResponse> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1318Model}
   * @memberof GetDeletePlanGoodsInfoService
   */
  private model: KYMW1318Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {GetDeletePlanGoodsInfoModel}
   * @memberof GetDeletePlanGoodsInfoService
   */
  private vo: GetDeletePlanGoodsInfoModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetDeletePlanGoodsInfoService
   */
  private successFunc: Function;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetDeletePlanGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        PCode: this.vo.pCode,
        MediumType: this.vo.mediumType,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetDeletePlanGoodsInfoService
   */
  execute(model: KYMW1318Model, vo: GetDeletePlanGoodsInfoModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getDeletePlanGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof GetDeletePlanGoodsInfoService
   */
  success(data: GetDeletePlanGoodsInfoResponse): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
